<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="app-container">
    <!-- Header Section -->
    <Header
      @handleLoginSelection="handleLoginSelection"
      @handleSignUpSelection="handleSignUpSelection"
    />

    <!-- Main Content -->
    <main class="container">
      <div class="left-container">
        <div v-if="listing" class="listing-details">
          <div v-if="listing" class="listing-info">
            <h2>{{ listing.title }}</h2>
            <h6 class="subheading">{{ listing.location }}</h6>
            <div
              v-if="!listing?.isActive && !listing?.isCompleted"
              style="margin-top: 0.5rem"
            >
              <Chip
                :class="[
                  'selected-chip',
                  'small-chip',
                  // { 'disabled-chip': !slot.isAvailable },
                ]"
                >Coming Soon</Chip
              >
            </div>
            <div v-else-if="listing?.isCompleted" style="margin-top: 0.5rem">
              <Chip
                :class="[
                  'selected-chip',
                  'small-chip',
                  // { 'disabled-chip': !slot.isAvailable },
                ]"
                >Sold out</Chip
              >
            </div>
            <!-- <div
                  v-if="!flight.isActive && !flight.isCompleted"
                  class="chip"
                >
                  Coming soon
                </div>
                <div v-else-if="flight.isCompleted" class="chip">Sold out</div> -->
            <img :src="listing.bannerUrl" class="listing-cover" />

            <div class="event-header">
              <div class="event-header-info">
                <h3 class="h3-style">Remote drone tour hosted by Skyhost</h3>
                <h6 class="subheading">
                  25 minutes interactive flight, 15 minutes Q&A
                </h6>
              </div>
              <!-- <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8jXULUjL7PbaFClpallWqF4YxmYjmYQZdCQ&s"
                alt="User"
                class="user-image"
              /> -->
            </div>

            <hr class="line-divider" />

            <div class="listing-features">
              <div class="feature-item">
                <vue-feather type="monitor" size="20"></vue-feather>
                <div class="feature-item-content">
                  <strong>Group viewing</strong>
                  <p>You'll have the event to yourself and the other guests</p>
                </div>
              </div>
              <div class="feature-item">
                <vue-feather type="mic" size="20"></vue-feather>
                <div class="feature-item-content">
                  <strong>Interactive flight</strong>
                  <p>Engage with the pilot and the guests</p>
                </div>
              </div>
              <div class="feature-item">
                <vue-feather type="radio" size="20"></vue-feather>
                <div class="feature-item-content">
                  <strong>Real time</strong>
                  <p>Low latency live streaming</p>
                </div>
              </div>
            </div>

            <h5 class="listing-description">{{ listing.description }}</h5>

            <!-- <hr class="line-divider" /> -->

            <div v-if="listing?.isActive" class="disclaimer">
              <vue-feather
                type="alert-triangle"
                size="18"
                class="warning-icon"
              />
              <span>
                Note: Your flight is only confirmed when at least 6 tickets are
                booked for a given slot.
              </span>
            </div>

            <!-- Key Points Widget -->
            <!-- <div class="key-points-container">
              <div class="key-point-widget">
                <span class="key-point-icon">🌍</span>
                <span class="key-point-text"> Travel the world together! </span>
              </div>
              <div class="key-point-widget">
                <span class="key-point-icon">🎂</span>
                <span class="key-point-text"> Celebrate birthday parties </span>
              </div>
              <div class="key-point-widget">
                <span class="key-point-icon">👨‍👩‍👧‍👦</span>
                <span class="key-point-text">
                  Get togethers with friends and family
                </span>
              </div>
              <div class="key-point-widget">
                <span class="key-point-icon">🧑‍✈️</span>
                <span class="key-point-text"> Max 8 tickets per flight </span>
              </div>
              <div class="key-point-widget">
                <span class="key-point-icon">🚁</span>
                <span class="key-point-text">
                  Live, aerial, educational flight with your child
                </span>
              </div>
              <div class="key-point-widget">
                <span class="key-point-icon">🏫</span>
                <span class="key-point-text">
                  Invite classmates to join from their homes, or watch together
                  on a big screen
                </span>
              </div>
            </div> -->

            <hr class="line-divider" />

            <div class="map-container">
              <h3 class="h3-style">Where we'll be flying</h3>
              <div class="map-image">
                <MapComponent
                  :latitude="listing.latitude"
                  :longitude="listing.longitude"
                />
              </div>
              <div class="location-coordinates">
                <strong class="location">{{
                  getTruncatedDescription(listing.location, 60)
                }}</strong>
                <div class="coordinates">
                  <p class="latitude">{{ listing.latitude }} N</p>
                  <p class="longitude">{{ listing.longitude }} E</p>
                </div>
              </div>
            </div>

            <hr class="line-divider" />

            <div class="things-container">
              <h3 class="h3-style">Things to know</h3>
              <div class="things-list">
                <div class="thing-item">
                  <vue-feather type="check-circle" size="18" />
                  <span>Check-in 15 minutes before departure</span>
                </div>
                <div class="thing-item">
                  <vue-feather type="wifi" size="18" />
                  <span>Ensure a stable internet connection</span>
                </div>
                <div class="thing-item">
                  <vue-feather type="user-check" size="18" />
                  <span
                    >Do not ask for personal contacts from pilots or other
                    participants</span
                  >
                </div>
                <div class="thing-item">
                  <vue-feather type="mic" size="18" />
                  <span
                    >Please mute your microphone when you are not speaking</span
                  >
                </div>
                <div class="thing-item">
                  <vue-feather type="x-circle" size="18" />
                  <span>No unauthorized recording</span>
                </div>
                <div class="thing-item">
                  <vue-feather type="user-x" size="18" />
                  <span>No harassment</span>
                </div>
              </div>
            </div>

            <hr class="line-divider" />

            <div class="cancellation-container">
              <h3 class="h3-style">Cancellation policy</h3>

              <p class="cancellation-intro">
                Please note that this tour can only be cancelled by pilots in
                specific circumstances. Credits will be automatically refunded
                according to the policy below.
              </p>

              <div class="cancellation-timeline">
                <div class="cancellation-section">
                  <div class="time-period">
                    <h4>Weather issues</h4>
                    <p>Pilot cancellation</p>
                  </div>
                  <div class="refund-policy">
                    <h4>Full credit refund</h4>
                    <p>Get back 100% of what you paid.</p>
                  </div>
                </div>

                <hr class="policy-divider" />

                <div class="cancellation-section">
                  <div class="time-period">
                    <h4>Permit or regulatory issues</h4>
                    <p>Pilot cancellation</p>
                  </div>
                  <div class="refund-policy">
                    <h4>Full credit refund</h4>
                    <p>Get back 100% of what you paid.</p>
                  </div>
                </div>

                <hr class="policy-divider" />

                <div class="cancellation-section">
                  <div class="time-period">
                    <h4>Safety concerns</h4>
                    <p>Pilot cancellation</p>
                  </div>
                  <div class="refund-policy">
                    <h4>Full credit refund</h4>
                    <p>Get back 100% of what you paid.</p>
                  </div>
                </div>

                <hr class="policy-divider" />

                <div class="cancellation-section">
                  <div class="time-period">
                    <h4>No show</h4>
                    <p>Guest doesn't attend the tour</p>
                  </div>
                  <div class="refund-policy">
                    <h4>No credit refund</h4>
                    <p>This reservation is non-refundable.</p>
                  </div>
                </div>
              </div>

              <p class="policy-note">
                You'll be notified immediately if your tour is cancelled. Users
                currently cannot cancel bookings themselves.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="right-container">
        <div class="booking-container" v-if="listing?.isActive">
          <div class="booking-header">
            <!-- <div class="credit-container">
              <h3>1 Credit</h3>
              <span>per private tour</span>
            </div> -->
            <div class="timezone-selector">
              <select v-model="userTimezone" class="timezone-select">
                <option v-for="tz in timezones" :key="tz" :value="tz">
                  {{ formatTimezone(tz) }}
                </option>
              </select>
              <p class="timezone-info">
                <vue-feather type="clock" size="14"></vue-feather>
                View times in your preferred timezone
              </p>
            </div>
          </div>

          <div
            class="select-time-header"
            style="padding: 0 1.5rem; margin-top: 1rem"
          >
            <h4>Select date</h4>
            <!-- <p>({{ userTimezone }})</p> -->
          </div>

          <VCalendar
            :key="calendarKey"
            :attributes="attrs"
            :disabled-dates="disabledDates"
            title-position="left"
            borderless
            expanded
            transparent
            @dayclick="handleDayClickNew"
            :min-date="displayStartDate"
            :max-date="displayEndDate"
            style="padding: 0 1rem; padding-top: 0.5rem"
          />

          <div class="booking-info">
            <div class="select-time-header" style="margin-bottom: 1rem">
              <h4>Select Time</h4>
              <!-- <p>({{ userTimezone }})</p> -->
            </div>

            <!-- Add this new section for when no slots are available -->
            <div v-if="!slots.length" class="empty-slots-container">
              <vue-feather type="calendar" size="18" class="empty-slots-icon" />
              <p class="empty-slots-message">
                Select an available date to view time slots
              </p>
            </div>

            <!-- Existing slots container -->
            <div v-else class="slots-container">
              <Chip
                v-for="slot in slots"
                :key="slot.timeSlot"
                :class="[
                  'small-chip',
                  selectedSlot === slot
                    ? 'selected-chip'
                    : !slot.isAvailable
                    ? 'disabled-chip'
                    : getOccupancyPercentage(slot) >= 70
                    ? 'danger-chip'
                    : getOccupancyPercentage(slot) >= 50
                    ? 'warning-chip'
                    : 'available-chip',
                ]"
                @click="slot.isAvailable ? selectSlot(slot) : null"
                :style="{
                  textDecoration: !slot.isAvailable ? 'line-through' : 'none',
                }"
              >
                <div class="chip-content">
                  <span class="chip-time">{{ slot.timeString }}</span>
                  <span class="chip-availability">
                    {{ slot.currentGuestCount || 0 }}/{{
                      slot.maxGuestCount || 3
                    }}
                  </span>
                </div>
              </Chip>
            </div>
          </div>

          <!-- Guest Counter Section -->
          <div class="guest-counter-section">
            <div class="guest-counter-container">
              <div class="guest-counter-label">
                <h4>TICKETS</h4>
                <p>{{ guestCount }} ticket{{ guestCount > 1 ? "s" : "" }}</p>
              </div>
              <div class="guest-counter-controls">
                <button
                  @click="decrementGuests"
                  :disabled="guestCount <= 1"
                  class="guest-counter-btn"
                >
                  −
                </button>
                <button
                  @click="incrementGuests"
                  :disabled="guestCount >= maxSelectableGuests"
                  class="guest-counter-btn"
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <div class="booking-summary">
            <div class="summary-row">
              <div class="summary-label">
                <p>{{ guestCount }} ticket{{ guestCount > 1 ? "s" : "" }}</p>
              </div>
              <p class="summary-value">
                {{ totalCreditsNeeded }} credit{{
                  totalCreditsNeeded > 1 ? "s" : ""
                }}
              </p>
            </div>

            <div class="credit-balance">
              <p>Your Credit Balance</p>
              <p>{{ creditBalance }} credits</p>
            </div>

            <button
              class="book-button"
              @click="bookPrivateEvent()"
              :disabled="!selectedDate || !selectedSlot"
            >
              Book Now
            </button>

            <p class="terms-note">Terms and conditions apply</p>
          </div>
        </div>
      </div>
    </main>

    <!-- <Footer /> -->

    <SignUpModal
      :isOpen="isSignUpModalOpen"
      @close="closeSignUpModal"
      :onSubmit="handleSignUp"
      @openLoginModal="openLoginModal"
      :errorMessage="errorMessage"
    />

    <LoginModal
      :isOpen="isLoginModalOpen"
      @close="closeLoginModal"
      @openSignUpModal="openSignUpModal"
      :onSubmit="handleLoginButton"
      :errorMessage="errorMessage"
    />

    <ReservationConfirmModal
      v-if="showConfirmModal"
      :tourName="listing.title"
      :tourImage="listing.bannerUrl"
      :location="listing.location"
      :duration="30 + ' min'"
      :selectedDate="selectedDate"
      :selectedSlot="selectedSlot.timeString"
      :creditBalance="creditBalance"
      :guestCount="guestCount"
      :isAgent="isUserAgent"
      @close="showConfirmModal = false"
      @confirm="handleConfirmBooking"
    />
  </div>
</template>

<script>
import {
  getFirestore,
  doc,
  getDoc,
  addDoc,
  updateDoc,
} from "firebase/firestore";
import { isMobile } from "@/utils/helper";
import { computed } from "vue";
import { ref } from "vue";
import Chip from "primevue/chip";
import { auth, db } from "@/plugins/firebase";
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
} from "firebase/firestore";
import { useSessionStore } from "../stores/session";
import SignUpModal from "@/components/organisms/modal/signUpModal.vue";
import LoginModal from "../components/organisms/modal/loginModal.vue";
import { loginService, userAuth } from "../services/userAuth";
import { amplitude } from "../plugins/amplitude";
import Header from "@/components/organisms/Header.vue";
import MapComponent from "@/components/samplemap.vue";
import { truncateText } from "@/utils/helper";
import { useRoute } from "vue-router";
import { creditService } from "@/services/creditService";
import ReservationConfirmModal from "@/components/organisms/ReservationConfirmModal.vue";

export default {
  components: {
    Chip,
    SignUpModal,
    Header,
    MapComponent,
    LoginModal,
    ReservationConfirmModal,
  },
  data() {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return {
      listing: null,
      selectedDate: null,
      slots: [],
      selectedSlot: null,
      slotsByDate: new Map(),
      promoDiscount: 50,
      errorMessage: "",
      isSignUpModalOpen: false,
      isLoginModalOpen: false,
      selectedOption: null,
      listingId: null,
      userTimezone: userTimezone,
      timezones: Intl.supportedValuesOf("timeZone"),
      showConfirmModal: false,
      creditBalance: 0,
      displayStartDate: new Date(),
      displayEndDate: new Date(),
      guestCount: 1,
      guestInfo: [],
    };
  },
  computed: {
    isUserAuthenticated() {
      const sessionStore = useSessionStore();
      return sessionStore.userId !== null;
    },
    isUserAgent() {
      const sessionStore = useSessionStore();
      return sessionStore.user?.isAgent;
    },
    calendarKey() {
      return this.userTimezone;
    },
    maxSelectableGuests() {
      if (!this.selectedSlot) return 1;
      const available =
        (this.selectedSlot.maxGuestCount || 3) -
        (this.selectedSlot.currentGuestCount || 0);
      return Math.max(1, available);
    },
    totalCreditsNeeded() {
      return this.guestCount;
    },
    disabledDates() {
      if (
        !this.listing?.eventSchedule ||
        this.listing.eventSchedule.length === 0
      ) {
        return [];
      }

      // Get all available dates from the converted timezone schedule
      const availableDates = this.convertedTimezoneSchedule.map((event) => {
        // Parse the userDate string (e.g., "March 11, 2025") to create a proper date
        const dateParts = event.userDate.split(/[\s,]+/);
        const month = dateParts[0];
        const day = parseInt(dateParts[1]);
        const year = parseInt(dateParts[2]);

        // Create date object for comparison
        const monthIndex = new Date(`${month} 1, 2000`).getMonth();
        return new Date(year, monthIndex, day);
      });

      // Generate all dates between displayStartDate and displayEndDate
      const allDates = [];
      const currentDate = new Date(this.displayStartDate);
      const endDate = new Date(this.displayEndDate);

      while (currentDate <= endDate) {
        allDates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }

      // Filter out dates that have available slots
      const disabledDates = allDates.filter((date) => {
        return !availableDates.some(
          (availableDate) =>
            availableDate.getFullYear() === date.getFullYear() &&
            availableDate.getMonth() === date.getMonth() &&
            availableDate.getDate() === date.getDate()
        );
      });

      return disabledDates;
    },
    convertedTimezoneSchedule() {
      if (!this.listing || !this.listing.eventSchedule) {
        return [];
      }

      return this.listing.eventSchedule.map((event) => {
        const utcDate = new Date(event.datetime);

        // Format date and time in listing timezone
        const listingDate = utcDate.toLocaleDateString("en-US", {
          timeZone: this.listing.timezone,
          month: "long",
          day: "numeric",
          year: "numeric",
        });

        const listingTime = utcDate.toLocaleTimeString("en-US", {
          timeZone: this.listing.timezone,
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        // Format date and time in user timezone
        const userDate = utcDate.toLocaleDateString("en-US", {
          timeZone: this.userTimezone,
          month: "long",
          day: "numeric",
          year: "numeric",
        });

        const userTime = utcDate.toLocaleTimeString("en-US", {
          timeZone: this.userTimezone,
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        return {
          slotId: event.slotId,
          datetime: event.datetime,
          listingDate,
          listingTime,
          userDate,
          userTime,
          isAvailable: event.isAvailable,
          isLocked: event.isLocked,
          maxGuestCount: event.maxGuestCount || 3,
          currentGuestCount: event.currentGuestCount || 0,
        };
      });
    },
  },
  methods: {
    handleLoginSelection() {
      this.openLoginModal();
    },
    handleSignUpSelection() {
      this.openSignUpModal();
    },
    async handleLoginButton(data) {
      // Track login attempt
      amplitude.track("Login Form Submitted", {
        type: "login",
        source: "listing_page",
        email_domain: data.email.split("@")[1] || "unknown",
        timestamp: new Date().toISOString(),
      });

      this.errorMessage = "";

      try {
        const user = await loginService.loginUser(data.email, data.password);
        const sessionStore = useSessionStore();
        sessionStore.setUserId(user.uid);

        // Track successful login
        amplitude.track("Login Success", {
          userId: user.uid,
          email: user.email,
          source: "listing_page",
          timestamp: new Date().toISOString(),
        });

        this.closeLoginModal();

        // Set up credit balance listener with the new user ID
        this.setupCreditBalanceListener();
      } catch (error) {
        this.errorMessage = error.message;

        // Track login failure with specific error type
        let errorType = "unknown";
        if (error.message.includes("password")) {
          errorType = "wrong_password";
        } else if (error.message.includes("No account")) {
          errorType = "user_not_found";
        } else if (error.message.includes("network")) {
          errorType = "network_error";
        } else if (error.message.includes("Too many failed")) {
          errorType = "too_many_attempts";
        }

        amplitude.track("Login Failed", {
          error_type: errorType,
          error_message: error.message,
          source: "listing_page",
          timestamp: new Date().toISOString(),
        });
      }
    },
    openLoginModal() {
      this.isLoginModalOpen = true;
    },
    closeLoginModal() {
      this.isLoginModalOpen = false;
      this.errorMessage = "";
    },
    openSignUpModal() {
      this.isSignUpModalOpen = true;
      // Track when signup modal is opened
      amplitude.track("SignUp Modal Opened", {
        source: "listing_page",
        listingId: this.listingId,
        listingTitle: this.listing?.title || "unknown",
        timestamp: new Date().toISOString(),
      });
    },
    closeSignUpModal() {
      this.isSignUpModalOpen = false;
      this.errorMessage = "";
    },
    getTruncatedDescription(description, maxLength) {
      return truncateText(description, maxLength); // Adjust the character limit as needed
    },
    fetchListing() {
      const db = getFirestore();
      const listingRef = doc(db, "listings", this.listingId);
      getDoc(listingRef).then((doc) => {
        if (doc.exists()) {
          this.listing = doc.data();
        } else {
          console.log("No such document!");
        }
      });
    },
    convertToUserTimeZone(utcDate, timeZone) {
      // Convert the UTC date to the user's timezone in 12-hour format
      const date = new Date(utcDate); // Convert to Date object
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone,
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      return formatter.format(date); // Returns time in "hh:mm AM/PM" format
    },
    convertData(data, timeZone) {
      // Function to convert the time and date to user's timezone
      const convertedDate = this.convertToUserTimeZone(
        data.timeSlot.date,
        timeZone
      );
      return {
        ...data,
        timeSlot: {
          ...data.timeSlot,
          timeString: convertedDate, // Update timeString in user timezone
          date: new Date(data.timeSlot.date).toLocaleString("en-US", {
            timeZone,
          }), // Update date to user timezone
        },
      };
    },
    handleDayClickNew(date) {
      console.log("handleDayClickNew called with date:", date.id);
      this.selectedSlot = null;
      // Reset slots at the beginning to clear any previous selection
      this.slots = [];

      // Format the selected date to YYYY-MM-DD for comparison
      const selectedDateStr = new Date(date.id).toISOString().split("T")[0];
      console.log("Selected date (YYYY-MM-DD):", selectedDateStr);

      // Check if this date exists in our convertedTimezoneSchedule
      const eventsOnSelectedDate = this.convertedTimezoneSchedule.filter(
        (event) => {
          // Instead of converting to Date object which causes timezone issues,
          // directly compare with the calendar date by formatting both to the same format

          // Get the month, day, and year from userDate string (e.g., "March 11, 2025")
          const dateParts = event.userDate.split(/[\s,]+/); // Split by spaces and commas
          const month = dateParts[0]; // "March"
          const day = parseInt(dateParts[1]); // 11
          const year = parseInt(dateParts[2]); // 2025

          // Get the calendar date components
          const calDate = new Date(date.id);
          const calMonth = calDate.toLocaleString("en-US", { month: "long" }); // "March"
          const calDay = calDate.getDate(); // 10
          const calYear = calDate.getFullYear(); // 2025

          // Simple comparison of components
          const isMatch =
            month === calMonth && day === calDay && year === calYear;

          return isMatch;
        }
      );

      console.log(
        `Found ${eventsOnSelectedDate.length} events on selected date in user timezone`
      );

      // Always update the selected date to highlight it in the calendar
      this.selectedDate = date.id;

      if (eventsOnSelectedDate.length === 0) {
        console.log("No available events on this date in your timezone");
        // Update calendar attributes with empty date styling
        // this.updateEmptyDateSelection();
        return;
      }

      // Map the events to slots format
      this.slots = eventsOnSelectedDate.map((event) => {
        return {
          timeSlot: {
            date: event.datetime,
            timeString: event.userTime,
          },
          isAvailable: event.isAvailable,
          isLocked: event.isLocked || false,
          slotId: event.slotId,
          timeString: event.userTime, // Add directly to the object for easier access
          maxGuestCount: event.maxGuestCount || 3,
          currentGuestCount: event.currentGuestCount || 0,
        };
      });

      // Update calendar attributes to show selected date
      this.updateCalenderAttributes();
    },
    async handleSignUp(data) {
      console.log("Sign up form submitted!");
      this.errorMessage = "";

      // Track signup attempt with more detailed information
      amplitude.track("SignUp Form Submitted", {
        type: "signUp",
        source: "listing_page",
        listingId: this.listingId,
        listingTitle: this.listing?.title || "unknown",
        timestamp: new Date().toISOString(),
      });

      try {
        const user = await userAuth.signUpUser(
          data.username,
          data.email,
          data.password,
          data.confirmPassword
        );
        console.log("Signed in as:", user.email);
        const sessionStore = useSessionStore();
        sessionStore.setUserId(user.uid);

        // Track successful signup
        amplitude.track("SignUp Success", {
          userId: user.uid,
          email: user.email,
          displayName: user.displayName || data.username,
          source: "listing_page",
          listingId: this.listingId,
          timestamp: new Date().toISOString(),
        });

        this.closeSignUpModal();

        // Set up credit balance listener with the new user ID
        this.setupCreditBalanceListener();
      } catch (error) {
        console.log(error);
        this.errorMessage = error.message;

        // Track signup failure with specific error type
        let errorType = "unknown_error";
        if (error.message.includes("already in use")) {
          errorType = "email_already_in_use";
        } else if (error.message.includes("Invalid email")) {
          errorType = "invalid_email";
        } else if (error.message.includes("weak")) {
          errorType = "weak_password";
        } else if (error.message.includes("network")) {
          errorType = "network_error";
        } else if (error.message.includes("match")) {
          errorType = "passwords_dont_match";
        } else if (error.message.includes("fill in all")) {
          errorType = "missing_fields";
        } else if (error.message.includes("disabled")) {
          errorType = "account_disabled";
        }

        // Track signup failure with error information
        amplitude.track("SignUp Failed", {
          errorCode: error.code || "unknown_error",
          errorType: errorType,
          errorMessage: error.message,
          source: "listing_page",
          listingId: this.listingId,
          timestamp: new Date().toISOString(),
        });
      }
    },
    selectSlot(slot) {
      this.selectedSlot = slot;
      // Reset guest count when selecting a new slot
      this.guestCount = 1;
    },
    incrementGuests() {
      if (this.guestCount < this.maxSelectableGuests) {
        this.guestCount++;
      }
    },
    decrementGuests() {
      if (this.guestCount > 1) {
        this.guestCount--;
      }
    },
    /**
     * https://stackoverflow.com/questions/66382652/how-to-style-vue-v-calendar-io-date-circle-color-and-text-color
     */
    updateCalenderAttributes() {
      this.attrs = [
        {
          key: "today",
          dot: {
            color: "#42b983",
          },
          dates: new Date(),
        },
        {
          key: "selected",
          highlight: {
            style: {
              backgroundColor: "#000",
            },
            fillMode: "solid",
          },
          dates: this.selectedDate ? [this.selectedDate] : [],
        },
      ];
    },
    async bookPrivateEvent() {
      if (!this.isUserAuthenticated) {
        this.openSignUpModal();
        return;
      }

      this.showConfirmModal = true;
    },
    async handleConfirmBooking(confirmData = {}) {
      const { guestInfo = [] } = confirmData;
      this.guestInfo = guestInfo;
      try {
        const sessionStore = useSessionStore();
        const userId = sessionStore.userId;

        const convertedEvent = this.convertedTimezoneSchedule.find(
          (event) => event.slotId === this.selectedSlot.slotId
        );

        // For backward compatibility, maintain the original structure too
        const reservationData = {
          listingId: this.listingId,
          listingUserId: this.listing.creatorUserId,
          createdBy: auth.currentUser.uid,
          selectedDate: this.selectedDate,
          slotId: this.selectedSlot.slotId,
          userTimezone: this.userTimezone,
          listingTimezone: this.listing.timezone,
          listingDate: convertedEvent?.listingDate || "",
          listingTime: convertedEvent?.listingTime || "",
          eventSchedule: {
            listing: {
              timezone: this.listing.timezone,
              date: convertedEvent?.listingDate || "",
              time: convertedEvent?.listingTime || "",
            },
            user: {
              timezone: this.userTimezone,
              date: convertedEvent?.userDate || "",
              time: convertedEvent?.userTime || "",
            },
          },
          creditUsed: this.guestCount,
          guestCount: this.guestCount,
          guestInfo: this.guestInfo,
          isCancelled: false,
          isConfirmed: true,
          roomCode: null,
          createdAt: new Date(),
          updatedAt: new Date(),
        };

        // Update slot availability in eventSchedule
        if (
          this.listing.eventSchedule &&
          this.listing.eventSchedule.length > 0
        ) {
          // Find the slot in eventSchedule that matches the selected slot
          const slotIndex = this.listing.eventSchedule.findIndex(
            (event) => event.slotId === this.selectedSlot.slotId
          );

          if (slotIndex !== -1) {
            // Increment the current guest count by the number of guests
            this.listing.eventSchedule[slotIndex].currentGuestCount =
              (this.listing.eventSchedule[slotIndex].currentGuestCount || 0) +
              this.guestCount;

            // Check if the slot should be marked as unavailable
            const currentEvent = this.listing.eventSchedule[slotIndex];
            if (currentEvent.currentGuestCount >= currentEvent.maxGuestCount) {
              this.listing.eventSchedule[slotIndex].isAvailable = false;
            }

            // Update the listing in Firestore
            const listingRef = doc(db, "listings", this.listingId);
            await updateDoc(
              listingRef,
              { eventSchedule: this.listing.eventSchedule },
              { merge: true }
            );
          }
        }

        // Log reservation data for debugging
        console.log("Creating reservation with data:", {
          guestInfo: reservationData.guestInfo,
          guestCount: reservationData.guestCount,
          isAgent: this.isUserAgent,
        });

        // Create the reservation with the new structure
        const reservation = await addDoc(
          collection(db, "reservations"),
          reservationData // Use the new data structure
        );

        reservationData.id = reservation.id;
        reservationData.description = `Credit used for booking ${this.listing.title}`;

        // Consume the credits (multiple credits for multiple guests)
        await creditService.consumeCredit(
          userId,
          this.guestCount,
          reservationData
        );

        // Send confirmation email
        try {
          await this.sendConfirmationEmail(reservation.id, reservationData);
        } catch (error) {
          console.error("Failed to send confirmation email:", error);
          // Don't block the booking process if email fails
        }

        // Close modal and show success message
        this.showConfirmModal = false;

        // Optionally redirect to bookings page
        this.$router.push("/bookings");
      } catch (error) {
        console.error("Error booking private event:", error);
        // Handle error appropriately (show error message)
      }
    },
    async sendConfirmationEmail(reservationId, reservationData) {
      const sessionStore = useSessionStore();
      const userEmail = sessionStore.user?.email;

      if (!userEmail) {
        console.warn("User email not found, skipping confirmation email");
        return;
      }

      const reservationIdShort = reservationId.substring(0, 6).toUpperCase();
      const eventDate = new Date(
        reservationData.selectedDate
      ).toLocaleDateString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      });

      // Extract guest emails for BCC
      const guestEmails = this.guestInfo
        .filter((guest) => guest.email && guest.email.trim())
        .map((guest) => guest.email.trim());

      // Log guest information for debugging
      console.log("Guest information for email:", {
        guestInfo: this.guestInfo,
        guestEmails: guestEmails,
        isAgent: this.isUserAgent,
      });

      const emailData = {
        reservationId: reservationIdShort,
        email: userEmail,
        subject: `Reservation confirmed for ${this.listing.title} on ${eventDate} at ${this.selectedSlot.timeString}`,
        receiverName:
          sessionStore.user?.displayName || sessionStore.user?.email || "Guest",
        hostName: "Skyhost",
        bannerUrl: this.listing.bannerUrl || this.listing.imageUrl,
        eventName: this.listing.title,
        location: this.listing.location,
        eventDate: eventDate,
        eventTime: this.selectedSlot.timeString,
        guestCount: this.guestCount,
        amountPaid: `${this.guestCount} Credit${
          this.guestCount > 1 ? "s" : ""
        }`, // Dynamic based on guest count
        bcc: guestEmails, // Add guest emails as BCC
      };

      // https://skyhost.ai/send-mail
      // http://localhost:3001/v1/mail/send
      return fetch("https://skyhost.ai/send-mail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(emailData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Confirmation email sent successfully");
          return data;
        })
        .catch((error) => {
          console.error("Error sending confirmation email:", error);
          throw error;
        });
    },
    formatTimezone(tz) {
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: tz,
        timeZoneName: "long",
      });
      const parts = formatter.formatToParts(new Date());
      const timeZonePart = parts.find((p) => p.type === "timeZoneName");
      return `${tz} (${timeZonePart.value})`;
    },
    formatDateInTimezone(date, timezone) {
      // Format a date in the specified timezone
      return new Date(date).toLocaleDateString("en-US", {
        timeZone: timezone,
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    },
    updateDisplayDates() {
      if (
        !this.listing?.eventSchedule ||
        this.listing.eventSchedule.length === 0
      ) {
        // Use current date in the selected timezone
        const today = new Date();
        this.displayStartDate = today;
        this.displayEndDate = today;
        console.log("No event schedule, using today for both dates");
        return;
      }

      // Extract all dates from eventSchedule and convert to Date objects
      const dates = this.listing.eventSchedule.map(
        (event) => new Date(event.datetime)
      );

      // Find the earliest and latest dates
      const earliestDate = new Date(Math.min(...dates));
      const latestDate = new Date(Math.max(...dates));

      // Get today's date
      const today = new Date();

      // Set display dates (ensuring we don't use past dates)
      const startDate = earliestDate < today ? today : earliestDate;
      const endDate = latestDate;

      // Create timezone-adjusted dates by converting to string and back
      // This creates dates that, when displayed, will show in the user's selected timezone
      const startOptions = {
        timeZone: this.userTimezone,
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };

      const endOptions = {
        timeZone: this.userTimezone,
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };

      // Create a formatted string in the user's timezone
      const startString = startDate.toLocaleString("en-US", startOptions);
      const endString = endDate.toLocaleString("en-US", endOptions);

      // Store the timezone-adjusted dates
      this.displayStartDate = new Date(startString);
      this.displayEndDate = new Date(endString);
    },
    setupCreditBalanceListener() {
      // Clear any existing listener
      if (this.unsubscribe) {
        this.unsubscribe();
      }

      const sessionStore = useSessionStore();
      const userId = sessionStore.userId;

      // If no user is logged in, return early
      if (!userId) {
        this.creditBalance = 0;
        return;
      }

      // Set up listener for credit history to keep balance updated
      const q = query(
        collection(db, "credits"),
        where("userId", "==", userId),
        orderBy("createdAt", "desc")
      );

      this.unsubscribe = onSnapshot(q, (snapshot) => {
        const creditHistory = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        this.creditBalance =
          creditService.calculateCreditBalance(creditHistory);
      });
    },
    getOccupancyPercentage(slot) {
      const maxGuests = slot.maxGuestCount || 3;
      const currentGuests = slot.currentGuestCount || 0;
      if (maxGuests === 0) return 0;
      return (currentGuests / maxGuests) * 100;
    },
  },
  watch: {
    listing: {
      handler() {
        this.updateCalenderAttributes();
        this.updateDisplayDates();
      },
      deep: true,
    },
    userTimezone: {
      handler(newTimezone) {
        console.log("Timezone changed to:", newTimezone);

        // Step 1: Update the display dates for the calendar
        this.updateDisplayDates();

        // Step 2: Reset selected date to clear calendar selection
        this.selectedDate = null;

        // Step 3: Clear the slots array to remove time slot options
        this.slots = [];

        // Step 4: Reset the selected slot
        this.selectedSlot = null;

        // Step 5: Update calendar attributes to reflect the reset state
        this.updateCalenderAttributes();

        console.log("Calendar reset due to timezone change");
      },
    },
    convertedTimezoneSchedule: {
      handler() {
        // Remove setDisabledDatesNew call
      },
      deep: true,
    },
    listingId() {
      this.fetchListing();
    },
  },
  setup() {
    const mainContentClass = computed(() =>
      isMobile() ? "mobile-main-content" : "web-main-content"
    );
    const attrs = ref([
      // {
      //   key: "today",
      //   dot: {
      //     color: "#42b983",
      //   },
      //   dates: new Date(),
      // },
    ]);
    return {
      attrs,
      mainContentClass,
    };
  },
  mounted() {
    const route = useRoute();
    this.listingId = route.query.listingId;
  },
  async created() {
    // Initialize display dates
    this.updateDisplayDates();

    // Set up credit balance listener
    this.setupCreditBalanceListener();
  },
  beforeUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
};
</script>

<style scoped>
/* Container and layout */
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #fff;
  color: #333;
}

.v-calendar .vc-arrows button {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
  overflow: hidden;
  margin-top: 5rem;
}

.left-container {
  flex: 1.5;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
}

.left-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

.right-container {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}

.disclaimer {
  display: flex;
  align-items: flex-start;
  background-color: #fff3cd; /* Light yellow background */
  color: #856404; /* Dark yellow text */
  padding: 10px 15px; /* Padding for spacing */
  /* border: 1px solid #ffeeba; Border to define the section */
  border-radius: 5px; /* Rounded corners */
  margin-top: 30px;
  width: 100%;
  text-align: left;
  flex-direction: column;
}

.disclaimer span {
  font-size: 0.8rem;
}

.warning-icon {
  margin-bottom: 5px; /* Space between icon and text */
}

.subheading {
  color: #7e7e7e;
  text-align: left;
  font-weight: 400;
  font-size: 0.8;
}

.main-content {
  padding: 2rem;
}

.listing-details {
  display: grid;
  margin: 20px;
  width: 75%;
  height: auto;
  margin-bottom: 400px;
}

.listing-cover {
  width: 100%;
  height: auto;
  max-height: 350px;
  border-radius: 16px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  object-fit: cover;
}

.user-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.listing-features {
  margin-top: 30px;
  margin-bottom: 30px;
  border-radius: 8px;
  text-align: left;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.feature-item-content {
  margin-left: 16px;
}

.feature-item strong {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  text-align: left;
  display: block;
  margin-bottom: 4px;
}

.feature-item p {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  text-align: left;
  line-height: 1.4;
}

.map-container {
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: left;
}

.map-container strong {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  text-align: left;
}

.map-image {
  width: 100%;
  margin-top: -4rem;
  margin-bottom: 1rem;
}

.location-coordinates {
  display: flex;
  justify-content: space-between; /* Aligns items to the left and right */
  margin-top: 1rem; /* Add some spacing above */
}

.location {
  font-size: 1rem; /* Current style for location */
  color: #333; /* Darker color for location */
}

.coordinates {
  display: flex;
  flex-direction: row; /* Stack latitude and longitude vertically */
  align-items: flex-end; /* Align to the right */
  gap: 0.5rem; /* Add some spacing between latitude and longitude */
}

.latitude,
.longitude {
  font-size: 0.7rem; /* Smaller font size for coordinates */
  color: #7e7e7e; /* Lighter color for coordinates */
  font-weight: 200;
}

.things-container {
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: left;
}

.things-list {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
}

.thing-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.9rem; /* Adjust font size as needed */
  color: #333; /* Darker color for text */
}

.thing-item span {
  margin-left: 8px; /* Space between icon and text */
}

.listing-description {
  font-size: 0.9rem;
  /* color: #333; */
  line-height: 1.5;
  color: #282828;
  text-align: left;
  /* font-weight: 200; */
  /* font-size: 0.8; */
  /* line-height: 1.3; */
  margin-bottom: 1rem;
}

.listing-info {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
}

.booking-container {
  top: 5rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  width: 380px;
  margin: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.booking-header {
  padding-top: 1.5rem;
  padding-bottom: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
}

.credit-container {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.credit-container h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
}

.credit-container span {
  color: #6b7280;
  font-size: 0.9rem;
}

.booking-info {
  padding: 1.5rem;
  margin-top: -1rem;
}

.select-time-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.select-time-header h4 {
  font-size: 1rem;
  color: #111827;
  font-weight: 500;
}

.select-time-header p {
  color: #6b7280;
  font-size: 0.875rem;
}

.slots-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.booking-summary {
  padding: 1.5rem;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
  padding: 0; /* Add this to remove any potential padding */
}

.summary-label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  padding: 0; /* Reset any potential padding */
  margin: 0; /* Reset any potential margin */
}

.summary-label p {
  font-size: 0.9rem;
  color: #111827;
  font-weight: 500;
}

.summary-label span {
  font-size: 0.8rem;
  color: #6b7280;
}

.summary-value {
  font-size: 0.9rem;
  color: #111827;
  font-weight: 500;
}

.credit-balance {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-top: 1px solid #f3f4f6;
  margin-bottom: 1.5rem;
}

.credit-balance p {
  font-size: 0.9rem;
  color: #111827;
  font-weight: 500;
}

.book-button {
  width: 100%;
  padding: 0.875rem;
  background-color: #000;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.book-button:hover:not(:disabled) {
  background-color: #111827;
}

.book-button:disabled {
  background-color: #d1d5db;
  cursor: not-allowed;
}

.terms-note {
  text-align: center;
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 1rem;
}

/* Guest Counter Styles */
.guest-counter-section {
  padding: 0 1.5rem;
}

.guest-counter-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #fff;
}

.guest-counter-label h4 {
  font-size: 0.875rem;
  font-weight: 600;
  text-align: left;
  color: #111827;
  margin: 0 0 0.25rem 0;
  letter-spacing: 0.05em;
}

.guest-counter-label p {
  font-size: 0.875rem;
  text-align: left;
  color: #6b7280;
  margin: 0;
}

.guest-counter-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.guest-counter-btn {
  width: 32px;
  height: 32px;
  border: 1px solid #d1d5db;
  border-radius: 50%;
  background-color: #fff;
  color: #374151;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.guest-counter-btn:hover:not(:disabled) {
  border-color: #9ca3af;
  background-color: #f9fafb;
}

.guest-counter-btn:disabled {
  background-color: #f3f4f6;
  color: #d1d5db;
  cursor: not-allowed;
  border-color: #e5e7eb;
}

.small-chip {
  font-size: 0.875rem;
  padding: 0.5rem;
  border-radius: 20px;
  background-color: #f3f4f6;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
}

.selected-chip {
  background-color: #000;
  color: #fff;
}

.disabled-chip {
  background-color: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.available-chip {
  background-color: #d1fae5;
  color: #065f46;
}

.warning-chip {
  background-color: #ffedd5;
  color: #9a3412;
}

.danger-chip {
  background-color: #fee2e2;
  color: #b91c1c;
}

.line-divider {
  border: none;
  border-top: 1px solid #e6e4e4;
  margin-top: 15px;
  margin-bottom: 5px;
}

.line-divider1 {
  border: none;
  border-top: 1px solid #e6e4e4;
  margin: 10px 20px;
}

.main-btn {
  background-color: #000;
  color: white;
  padding: 0.5rem 1rem;
  margin: 10px 0;
  width: 85%;
  height: 40px;
  border-radius: 8px;
  border: 0px solid #000;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.main-btn:disabled {
  background-color: #ccc;
}

.event-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.event-header-info {
  flex-direction: column;
  justify-content: center;
}

.stepper-container {
  margin-bottom: 20px;
}

.step-item {
  font-size: 1rem;
  color: #333;
}

.content-panel {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
}

.content-box {
  width: 100%;
  height: 100%;
  border: 2px dashed #dcdcdc;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: #f7f7f7;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.btn-next {
  background-color: #000;
  color: #fff;
}

.btn-back {
  background-color: #e0e0e0;
  color: #000;
}

h2 {
  font-size: 1.5rem;
  color: #222;
  text-align: left;
  margin-bottom: 0.5rem;
}

h3 {
  color: #222;
  align-items: center;
}

.h3-style {
  margin-bottom: 0.5rem;
}

button.logout-button {
  border: none;
  border-radius: 50%;
  color: #333;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
}

button.logout-button:hover {
  background-color: #e5e7eb !important;
}

/* Add these new styles */
.empty-slots-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0.5rem;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px dashed #e5e7eb;
}

.empty-slots-icon {
  color: #9ca3af;
  margin-bottom: 0.5rem;
}

.empty-slots-message {
  color: #6b7280;
  font-size: 0.875rem;
  text-align: center;
  line-height: 1.25;
}

.timezone-selector {
  /* margin-top: 1rem; */
  /* padding-top: 1rem; */
  /* border-top: 1px solid #f3f4f6; */
}

.timezone-select {
  width: 100%;
  padding: 0.75rem;
  padding-right: 2rem; /* Increased right padding to move arrow away from border */
  border: 1px solid #000;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #111827;
  background-color: #fff;
  margin-bottom: 0.5rem;
  transition: all 0.2s ease;
  outline: none; /* Remove default outline */
  -webkit-appearance: none; /* For custom styling in Safari */
  -moz-appearance: none; /* For custom styling in Firefox */
  appearance: none; /* Standard property for custom styling */
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23000000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1em;
}

.timezone-select:hover {
  border-color: #333;
}

.timezone-select:focus {
  border-color: #000;
  box-shadow: 0 0 0 1px #000;
  outline: none;
}

.timezone-select:active {
  border-color: #000;
}

.timezone-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #6b7280;
  font-size: 0.75rem;
}

.timezone-info-section {
  margin: 2rem 0;
  text-align: left;
}

.timezone-details {
  margin: 1rem 0;
  padding: 1rem;
  background-color: #f9fafb;
  border-radius: 8px;
}

.timezone-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.timezone-row:last-child {
  margin-bottom: 0;
}

.slots-table {
  margin-top: 1rem;
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

th,
td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

th {
  background-color: #f9fafb;
  font-weight: 500;
  color: #111827;
}

.status-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
}

.status-badge.available {
  background-color: #dcfce7;
  color: #166534;
}

.status-badge.booked {
  background-color: #fee2e2;
  color: #991b1b;
}

/* Add padding to calendar to match other elements */
.calendar-padding {
  padding: 0 1.5rem;
  margin-top: 1rem;
}

.cancellation-container {
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: left;
}

.cancellation-intro {
  font-size: 0.9rem;
  color: #333;
  line-height: 1.5;
}

.cancellation-timeline {
  margin: 2rem 0;
}

.cancellation-section {
  display: flex;
  justify-content: space-between;
  margin: 1.5rem 0;
}

.time-period {
  width: 30%;
}

.refund-policy {
  width: 70%;
}

.time-period h4,
.refund-policy h4 {
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 0.2rem;
  color: #222;
}

.time-period p,
.refund-policy p {
  font-size: 0.85rem;
  color: #333;
  margin: 0;
}

.policy-divider {
  border: none;
  border-top: 1px solid #e6e4e4;
  margin: 1.5rem 0;
}

.policy-note {
  font-size: 0.9rem;
  color: #555;
  margin-top: 1.5rem;
}

.cancellation-list {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
}

.cancellation-list .thing-item {
  margin-bottom: 0.5rem;
}

.cancellation-list .thing-item span {
  margin-left: 8px;
}

.chip-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.2rem;
}

.chip-time {
  font-size: 0.7rem;
  font-weight: 500;
}

.chip-availability {
  font-size: 0.7rem;
  opacity: 0.7;
  font-weight: 400;
}

.key-points-container {
  margin-top: 1.5rem;
  margin-bottom: 2rem;
}

.key-point-widget {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.key-point-icon {
  font-size: 1.2rem;
  color: #000;
}

.key-point-text {
  font-size: 0.9rem;
  color: #333;
}
</style>
